import queryString from 'query-string';
import callApi, { CallApiResult, getCustomerId } from 'src/api';
import { blobErrorMessage } from 'src/api/blob-error';
import { CustomerOrdersFilterParams } from 'src/api/customer/orders';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';

/* Customer Information Downloads */

export const fetchCustomerDownloadTypes = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/resource/customer/' + customerId + '/downloadTypes';
    return callApi(endpoint);
};

export const fetchCustomerDownloadTopics = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/resource/customer/' + customerId + '/downloadTypes';
    return callApi(endpoint);
};

export const fetchCustomerDownloads = (
    typeName: string,
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const customerId = getCustomerId();
    const endpoint = `/api/resource/customer/${customerId}/downloads/download/${typeName}${query}`;

    return callApi(endpoint);
};

/* Customer Bill Downloads */

export const fetchCustomerBillsInfo = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/resource/customer/' + customerId + '/billsInformation';

    return callApi(endpoint);
};

export interface FetchCustomerBillsParams {
    year?: string;
    month?: string;
}

export const fetchCustomerBills = (
    params: FetchCustomerBillsParams,
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify({ ...params, ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const customerId = getCustomerId();
    const endpoint = `/api/resource/customer/${customerId}/bills${query}`;

    return callApi(endpoint);
};

/* Live-Runde 13: invoices like Mein Bereich › Bestellungen (ordering) and their ZIP (resourceservice) */

export type CustomerInvoicesQueryParams = PageableQueryParams & CustomerOrdersFilterParams;

export const fetchCustomerInvoices = (params: CustomerInvoicesQueryParams = {}): Promise<CallApiResult> => {
    let query = queryString.stringify(params, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const customerId = getCustomerId() === 'current' ? '' : '/' + getCustomerId();
    return callApi(`/api/customerOrders${customerId}/invoices${query}`);
};

/** Rejects with the server's reason (e.g. a foreign invoice, more than 200, a missing file). */
export const downloadCustomerInvoicesZip = async (ids: number[]): Promise<Blob> => {
    const { response, error } = await callApi<Blob>(`/api/resource/customer/${getCustomerId()}/bills/zip`, {
        method: 'POST',
        data: { ids },
        responseType: 'blob',
    });
    if (error || !response) throw new Error(await blobErrorMessage(error));
    return response.data;
};

/* Commission Bill Downloads */

export const fetchCustomerCommissionBillsInfo = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/resource/customer/' + customerId + '/commissionBillsInformation';

    return callApi(endpoint);
};

export interface FetchCustomerCommissionBillsParams {
    year?: string;
}

export const fetchCustomerCommissionBills = (
    params: FetchCustomerCommissionBillsParams,
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify({ ...params, ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const customerId = getCustomerId();
    const endpoint = `/api/resource/customer/${customerId}/commissionBills${query}`;

    return callApi(endpoint);
};
